import React, { useState } from 'react';
import PropTypes from 'prop-types';

// alphabetized
import EmailContactsButton from './email_contacts_button';
import EmailContactsModal from './email_contacts_modal';
import vahoy from '../../../javascript/vahoy';

function EmailContacts(props) {
  const {
    button_text: buttonText,
    button_class: buttonClass,
    source_request_id: sourceRequestId,
    source_request_share_with_sources_url: sourceRequestShareWithSourcesUrl,
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  const closeModal = () => {
    setShowPopup(false);
  };

  const showModal = () => {
    setShowPopup(true);
    vahoy.track('ReporterFollowup#showModal');
  };

  return (
    <>
      <EmailContactsButton
        buttonText={buttonText}
        buttonClass={buttonClass}
        clickEvent={showModal}
      />
      <EmailContactsModal
        sourceRequestId={sourceRequestId}
        sourceRequestShareWithSourcesUrl={sourceRequestShareWithSourcesUrl}
        showPopup={showPopup}
        closeModal={closeModal}
      />
    </>
  );
}

EmailContacts.propTypes = {
  source_request_id: PropTypes.number.isRequired,
  source_request_share_with_sources_url: PropTypes.string.isRequired,
  button_text: PropTypes.string.isRequired,
  button_class: PropTypes.string.isRequired,
};

export default EmailContacts;
